var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress",staticStyle:{"background-color":"rgba(0, 0, 0, 0.25)"}},[_c('div',{class:_vm.color,style:('width:'+_vm.percentage+'%;'),attrs:{"role":"progressbar","aria-valuenow":_vm.percentage,"aria-valuemin":"0","aria-valuemax":"100"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }